/**
 * Profile Page Component - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * A comprehensive profile page with advanced features:
 * - Member profile display with Auth0 integration
 * - Multi-user profile viewing capability
 * - Dynamic email detection from URL state or logged-in user
 * - Loading state management
 * - Clean and responsive profile layout
 * - Auth0 user context integration
 * - URL state-based profile switching
 * 
 * Features:
 * - View own profile
 * - Auth0 user authentication integration
 * - URL state-based email parameter handling
 * - Loading state for unauthenticated users
 * - MemberProfile component integration
 * - Responsive design for various screen sizes
 * - Clean and minimal profile interface
 * 
 * @returns {JSX.Element} Profile page component with member profile display
 */
import React, { useContext } from 'react';
import MemberProfile from '../components/Profile/MemberProfile';
import './Profile.css';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../components/Auth/AuthContext';

/**
 * Profile component for displaying member profiles
 * with Auth0 integration and multi-user support
 */
function Profile() {
    const { user: [user] } = useContext(AuthContext);
    const location = useLocation();
    
    // Get the email - either from the URL state (if viewing someone else's profile) or the logged-in user
    const email = location.state?.viewEmail || user?.profile?.email;

    if (!email) {
        return (
            <div className='totalPage' id='profilePage'>
                <section className="wrapper">
                    <div className="container mt-6 pb-6">
                        <div>Loading...</div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className='totalPage' id='profilePage'>
            <section className="wrapper">
                <div className="container mt-6 pb-6">
                    <MemberProfile email={email} />
                </div>
            </section>
        </div>
    );
}

export default Profile;